export default __webpack_public_path__ + "static/favicon-d244a13e186d13f54c9f50ecdb76fd0f.ico";